import { useSelector } from 'react-redux';

import type { MediaItem } from 'src/components/organisms/ProductMediaCarousel/types';
import { selectFavouriteProduct } from 'src/redux/favourites/selectors';
import { selectProduct, selectProductMedia } from 'src/redux/product/selectors';

/**
 * View model for the product media carousel. Owns the image, video and
 * favourite reads, so the carousel takes props and its interaction handlers
 * come from useProductMediaCarouselActions alongside.
 */
export interface ProductMediaViewModel {
  favouriteProduct: boolean;
  media: MediaItem[];
  productCode: number;
}

export const useProductMediaViewModel = (): ProductMediaViewModel => {
  const product = useSelector(selectProduct);
  const media = useSelector(selectProductMedia);
  const favouriteProduct = useSelector(selectFavouriteProduct);

  return {
    favouriteProduct,
    media,
    productCode: product.code,
  };
};
